// sagas.js
import { call, put, takeLatest } from 'redux-saga/effects';

import {
  FETCH_ALTERNATIVE_PRODUCTS_REQUEST,
  fetchAlternativeProductsSuccess,
  fetchAlternativeProductsFailure,
} from '../actions/fetchAlternativeProductsAction';
import { getRequest } from 'api/apiCall';
import captureCustomSentryEvent from "Sentry/captureCustomSentryEvent";

// API Request Function
function* fetchAlternativeProductsAPI(action) {
  try {
    const { variantId } = action.payload;
    const response = yield call(getRequest, `/products/alternative-products/${variantId}`);
    if (response) {
      return response;
    } else {
      throw new Error("Failed to fetch alternative products: " + response);
    }
  } catch (error) {
    captureCustomSentryEvent("fetchAlternativeProductsAPI", error);
    throw error;
  }
}

// Worker Saga
function* fetchAlternativeProducts(action) {
  try {
    const response = yield call(fetchAlternativeProductsAPI, action);
    yield put(fetchAlternativeProductsSuccess(response));
  } catch (error) {
    yield put(fetchAlternativeProductsFailure(error));
  }
}

// Watcher Saga
function* watchFetchAlternativeProducts() {
  yield takeLatest(FETCH_ALTERNATIVE_PRODUCTS_REQUEST, fetchAlternativeProducts);
}

export default watchFetchAlternativeProducts;

